<div class="active-placemark-shop">
  <div class="address text-b2-s-500 text-md-b4-m-500">
    {{ shop().addressFormatted }}
  </div>
  <div class="display-name text-b3-s-300 text-md-c1-l-500">{{ shop().displayName }}</div>
  @if (shop().distanceKm; as distanceKm) {
    <div class="distance text-b3-s-500">{{ distanceKm | sdDistanceFromYou }} от вас</div>
  }

  <div class="working-time">
    <sd-shop-working-time [shop]="shop()"></sd-shop-working-time>
  </div>

  @if (showAvailability()) {
    @let pickupDate = shop().pickupDate;
    @let deliveryDate = pickupDate ? (pickupDate | sdDeliverIn: 'dd.MM' | async) : null;

    @if (shop().available) {
      <div class="availability text-b3-s-500 color-green">
        в наличии {{ shop().available | formattedNumber: '1.0-2' }} {{ shop().unit?.name || '' }}
      </div>
    } @else if (pickupDate) {
      <div class="availability text-b3-s-500 color-orange">
        привезем {{ deliveryDate }}
        @if (deliveryDate !== 'сегодня') {
          при заказе сегодня
        }
      </div>
    }
  }

  @if (shop().url) {
    <a [href]="'https://sdvor.com' + shop().url" class="shop-link">о магазине</a>
  }
</div>
